/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Ai_Style_Needs_SourceInputs */

const cs_templates_ai_style_needs_source = /** @type {(inputs: Templates_Ai_Style_Needs_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdřív přidejte layout nebo zdroj a pak na něj přeneste styl.`)
};

const en_templates_ai_style_needs_source = /** @type {(inputs: Templates_Ai_Style_Needs_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add layout or source first, then transfer style onto it.`)
};

/**
* | output |
* | --- |
* | "Add layout or source first, then transfer style onto it." |
*
* @param {Templates_Ai_Style_Needs_SourceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_ai_style_needs_source = /** @type {((inputs?: Templates_Ai_Style_Needs_SourceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Ai_Style_Needs_SourceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_ai_style_needs_source(inputs)
	return cs_templates_ai_style_needs_source(inputs)
});